var render = function () {
  var _vm$author, _vm$author$thumb, _vm$author2, _vm$author2$thumb, _vm$author3, _vm$author3$name, _vm$author4, _vm$author4$name, _vm$author5;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('v-container', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-img', {
    class: {
      'v-sheet--outlined': !((_vm$author = _vm.author) === null || _vm$author === void 0 ? void 0 : (_vm$author$thumb = _vm$author.thumb) === null || _vm$author$thumb === void 0 ? void 0 : _vm$author$thumb.url)
    },
    attrs: {
      "src": (_vm$author2 = _vm.author) === null || _vm$author2 === void 0 ? void 0 : (_vm$author2$thumb = _vm$author2.thumb) === null || _vm$author2$thumb === void 0 ? void 0 : _vm$author2$thumb.url,
      "aspect-ratio": 1 / 1,
      "width": "100%"
    },
    scopedSlots: _vm._u([{
      key: "placeholder",
      fn: function fn() {
        return [_c('v-overlay', {
          attrs: {
            "absolute": "",
            "dark": "",
            "color": "transparent"
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "grey",
            "size": "40"
          }
        }, [_vm._v("mdi-account")])], 1)];
      },
      proxy: true
    }])
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-card', {
    staticClass: "primary--text",
    attrs: {
      "flat": "",
      "tile": ""
    }
  }, [_c('v-card-subtitle', {
    staticClass: "pa-0 font-weight-bold primary--text"
  }, [_vm._v(" " + _vm._s((_vm$author3 = _vm.author) === null || _vm$author3 === void 0 ? void 0 : (_vm$author3$name = _vm$author3.name) === null || _vm$author3$name === void 0 ? void 0 : _vm$author3$name.en) + " ")]), _c('v-card-title', {
    staticClass: "px-0 py-30"
  }, [_vm._v(" " + _vm._s((_vm$author4 = _vm.author) === null || _vm$author4 === void 0 ? void 0 : (_vm$author4$name = _vm$author4.name) === null || _vm$author4$name === void 0 ? void 0 : _vm$author4$name.ko) + " ")]), _c('v-divider', {
    staticClass: "mb-20"
  }), _c('author-view-desc', _vm._b({}, 'author-view-desc', {
    author: _vm.author
  }, false)), _c('v-divider', {
    staticClass: "mt-20"
  }), _c('v-card-text', {
    staticStyle: {
      "white-space": "pre-line grey-68--text"
    }
  }, [_vm._v(" " + _vm._s((_vm$author5 = _vm.author) === null || _vm$author5 === void 0 ? void 0 : _vm$author5.content) + " ")])], 1)], 1)], 1), _c('author-view-works', _vm._b({}, 'author-view-works', {
    _author: _vm._author
  }, false)), _c('v-fade-transition', {
    attrs: {
      "leave-absolute": ""
    }
  }, [_c('v-overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.loading,
      expression: "loading"
    }],
    attrs: {
      "color": "white",
      "light": ""
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "color": "primary",
      "indeterminate": "",
      "size": "100",
      "width": "5"
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }